/* global axios */
import ApiClient from './ApiClient';

class UazapiAPI extends ApiClient {
  constructor() {
    super('inboxes', { accountScoped: true });
  }

  createChannel(name) {
    return axios.post(`${this.baseUrl()}/channels/uazapi_channel`, {
      uazapi_channel: { name },
    });
  }

  status(inboxId) {
    return axios.get(`${this.url}/${inboxId}/uazapi`);
  }

  connect(inboxId) {
    return axios.post(`${this.url}/${inboxId}/uazapi/connect`);
  }

  disconnect(inboxId) {
    return axios.post(`${this.url}/${inboxId}/uazapi/disconnect`);
  }

  adopt(inboxId, instanceId) {
    return axios.post(`${this.url}/${inboxId}/uazapi/adopt`, {
      instance_id: instanceId,
    });
  }

  instances() {
    return axios.get(`${this.baseUrl()}/uazapi_instances`);
  }
}

export default new UazapiAPI();
